import { gql } from '@apollo/client';

export const SET_PROFESSIONAL_CONTEXT_MUTATION = gql`
  mutation setProfessionalContext($input: ProfessionalContextInput!) {
    setProfessionalContext(input: $input) {
      expertiseAreas
      educationLevel
      currentProgram
      fieldOfStudy
      institution
      jobTitle
      yearsExperience
      credentials {
        id
        title
        issuer
        year
        expiryYear
        link
      }
      updatedAt
    }
  }
`;
